
const Variables = {

 statusList : [
    { id: 1, label: "Open", value: 1, default: true, description: 'Additional calls and distribution are expected' },
    { id: 4, label: "Liquidated", value: 4, default: false, description: 'NO additional calls or distribution are expected' },
    { id: 2, label: "Draft", value: 2, default: false, description: 'Draft fund, will not be included in reporting' },
    { id: 100, label: "Deleted", value: 100, default: false, description: 'Deleted, will not be included in reporting' },

],

currencyList : [
   {
     id: 'EUR',
     label: 'EUR',
     icon: 'eu',
     description: 'Euro',
     date: '',
     rate: ''
   },
   {
     id: 'USD',
     label: 'USD',
     icon: 'us',
     description: 'US dollar',
     date: '',
     rate: ''
   },
   {
     id: 'CAD',
     label: 'CAD',
     icon: 'ca',
     description: 'Canadian dollar',
     date: '',
     rate: ''
   },
   {
     id: 'GBP',
     label: 'GBP',
     icon: 'gb',
     description: 'British pound',
     date: '',
     rate: ''
   },
   {
     id: 'NOK',
     label: 'NOK',
     icon: 'no',
     description: 'Norwegian krone',
     date: '',
     rate: ''
   },
   {
     id: 'CHF',
     label: 'CHF',
     icon: 'ch',
     description: 'Swiss franc',
     date: '',
     rate: ''
   },
 ],

 sectorList : [
    { "id": "business_services", "label": "Business Services" },
    { "id": "consumer_goods", "label": "Consumer Goods" },
    { "id": "diversified", "label": "Diversified" },
    { "id": "energy", "label": "Energy" },
    { "id": "finance", "label": "Finance" },
    { "id": "health", "label": "Health" },
    { "id": "industry", "label": "Industry" },
    { "id": "infrastructure", "label": "Infrastructure" },
    { "id": "technology", "label": "Technology" },
    { "id": "real_estate", "label": "Real Estate" },
    { "id": "impact", "label": "Impact" },
    { "id": "others", "label": "Others" },
],
 geographyList : [

    { id: 'Europe', label: 'Europe', parent: 'Global' },
    { id: 'North America', label: 'North America', parent: 'Global' },
    { id: 'Asia', label: 'Asia' },
    { id: 'Emerging', label: 'Emerging markets' },
    { id: 'Others', label: 'Others' },
    { id: 'Global', label: 'Global' },

],
assetType : {
   buyout: {
     label: 'Buyout fund (LBO) - Large',
     description: 'Combines investment funds with borrowed money',
     bgcolor: '#0DB197' // success teal
   },
 
   buyoutsmallmid: {
     label: 'Buyout fund (LBO) - Small / Mid',
     description: 'Combines investment funds with borrowed money',
     bgcolor: '#78E5CD' // lighter primary mint
   },
 
   growth: {
     label: 'Growth Equity',
     description: 'Growth capital invests in mature companies looking to grow their business by entering new markets or buying other companies',
     bgcolor: '#4AA3FF' // info blue
   },
 
   venture: {
     label: 'Venture Capital (VC) & Early growth',
     description: 'Funding early-stage startups and new businesses',
     bgcolor: '#6C8CFF' // derived blue-violet
   },
 
   co_invest: {
     label: 'Co-investment',
     description: 'Invest alongside others funds in the world.',
     bgcolor: '#8FB7FF' // lighter companion blue
   },
 
   secondaries: {
     label: 'Secondaries',
     description: 'Buying pre-existing investor commitments to private-equity funds.',
     bgcolor: '#E6B800' // gold
   },
 
   direct: {
     label: 'Direct Equity',
     description: 'Direct ownership of shares or stocks in a company',
     bgcolor: '#FF8A5B' // warm orange derived from danger
   },
 
  
 
   infrastructure: {
     label: 'Infrastructure',
     description: 'Infrastructure funds invest in assets that provide essential utilities or services',
     bgcolor: '#718190' // actual neutral steel
   },
   
   impact: {
     label: 'Impact',
     description: 'Impact fund',
     bgcolor: '#5FD6B3' // softer ESG mint
   },
 
   real_estate: {
     label: 'Real Estate',
     description: 'Real estate fund',
     bgcolor: '#74788D' // gray/slate
   },
 
   funds_of_funds: {
      label: 'Fund of Funds',
      description: 'Acts as an investor and buys into a portfolio of other private equity funds',
      bgcolor: '#A0AEC0' // muted institutional gray-blue
    },
    
    other: {
      label: 'Others',
      description: 'Other funds',
      bgcolor: '#5B6275' // dark slate gray
    },
 },

 portfolioColors: {
   0:  '#0DB197', // teal
   1:  '#4AA3FF', // blue
   2:  '#E6B800', // gold
   3:  '#6C8CFF', // indigo
   4:  '#FF8A5B', // orange
   5:  '#5FD6B3', // mint
   6:  '#718190', // steel gray
   7:  '#8D99AE', // blue gray
   8:  '#9B8AFB', // soft violet
   9:  '#FF3D60', // red
   10: '#00C2FF', // cyan
   11: '#7CCB5E', // green
   12: '#C59D00', // dark gold
   13: '#A06CFF', // purple
   14: '#FF6B6B', // coral
   15: '#3E517A', // navy slate
   16: '#26B99A', // emerald teal
   17: '#F4A261', // sand orange
   18: '#577590', // muted blue
   19: '#B56576', // muted burgundy
 },

 transactionType : [
    { id: 'capital_call',value: 'capital_call', label: 'Capital Call', sign: '-',color:'#ff3d60' },
    { id: 'distribution',value: 'distribution', label: 'Distribution', sign: '+',color:'#0DB197' },
    { id: 'recallable',value: 'recallable', label: 'Recallable Capital Repayment', sign: '+',color:'#7CCB5E' },
    { id: 'dividend',value: 'dividend', label: 'Dividend payment', sign: '+' ,color:'#0DB197'},
    { id: 'setup_fee',value: 'setup_fee', label: 'Setup Fee', sign: '-',color:'#ff3d60' },
    { id: 'recalled_distributions',value: 'recalled_distributions', label: 'Recalled Distributions', sign: '-',color:'#ff3d60' }
    /*  { value: 'Reimbursment', label: 'Reimbursment', sign: '+' },
         { value: 'share_sold', label: 'Shares sold', sign: '+' },
         { value: 'share_purchase', label: 'Shares purchased', sign: '-' },
       */

],

/*
   investing: '#FFB84D',   // amber / capital deployment
   harvesting: '#0DB197',  // success teal-green
   liquidated: '#718190'   // neutral inactive*/

 dark_colorScheme :  {

    main_backgroundColor: '#1F2430',
    default_text: '#E6E8EC',
    secondary_backgroundColor: '#2A3140',
    selected_background: '#2A3140',
    selected_text: '#E6E8EC',
    actual_neutral: '#9AA0AC',
    expected_neutral: '#3E4757',
    actual_red: '#FF6B6B',
    actual_green: '#159A86',
    secondary: '#9AA0AC',
    primary: '#159A86',
    danger: '#FF6B6B',
    success: '#159A86',
    info: '#4aa3ff',
    gray: '#5B6577',
    dark: '#2a3042',
    gold: '#fcb92c'
  },

 light_colorScheme : {
    main_backgroundColor: '#FFFFFF',
    default_text: '#505a69',
    secondary_backgroundColor: '#F3F3F4',
    selected_background: '#F3F3F4',
    selected_text: '#000000',
    actual_neutral: '#718190',
    expected_neutral: '#DDDDDD',
    actual_red: '#FF3D60',
    actual_green: '#0FC074',
    secondary: '#74788d',
    primary: '#0DB197',
    danger: '#ff3d60',//#FF3D60
    success: '#0DB197', //#0ac074',
    info: '#4aa3ff',
    gray: '#E2E2E2',
    dark: '#2a3042',
    gold:'#E6B800'

  }, 
  printColorScheme : {
   main_backgroundColor: '#FFFFFF', // White remains unchanged
   default_text: '#000000', // Black remains unchanged
   secondary_backgroundColor: '#E6E6E6', // Softer gray for better print contrast
   selected_background: '#D9D9D9', // Light gray for selection visibility
   selected_text: '#000000', // Black remains unchanged
   actual_neutral: '#767676', // Mid-gray for better grayscale printing
   expected_neutral: '#B0B0B0', // Slightly darker gray to avoid blending into the background
   actual_red: '#B22222', // Darker red (firebrick) for better print contrast
   actual_green: '#2E8B57', // Darker green (sea green) for better print contrast
   secondary: '#666666', // Neutral dark gray to retain contrast
   primary: '#008080', // Teal, which prints better than light turquoise
   danger: '#B22222', // Matches actual_red for better printing
   success: '#2E8B57', // Matches actual_green for better printing
   info: '#1E4E8C', // Darker blue for better visibility in print
   gray: '#666666', // Ensuring consistency with secondary
   dark: '#222222', // Dark charcoal to maintain depth without oversaturation
    gold:'#E6B800'
},

   colorScheme :{
    main_backgroundColor: '#FFFFFF',
    default_text: '#505a69',
    secondary_backgroundColor: '#F3F3F4',
    selected_background: '#F3F3F4',
    selected_text: '#000000',
    actual_neutral: '#718190',
    expected_neutral: '#DDDDDD',
    actual_red: '#FF3D60',
    actual_green: '#0FC074',
    secondary: '#74788d',
    primary: '#0DB197',
    danger: '#ff3d60',//#FF3D60
    success: '#0DB197', //#0ac074',
    info: '#4aa3ff',
    gray: '#E2E2E2',
    dark: '#2a3042',
    gold:'#E6B800'

  }, 
  investmentCycleColors : {

   investing: '#FFB84D',   // amber / capital deployment
   harvesting: '#0DB197',  // success teal-green
   liquidated: '#718190'   // neutral inactive
 
 },
 
}

export  default Variables